import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';
import { TextField } from '@speeki/global-ui-components';

export const InformationWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius['8']}px;
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
        max-width: 460px;
        padding: 36px 32px 32px;
        width: 100%;
    `,
);

export const OptionalText = styled(Typography.TextBody_12_20)`
    font-weight: 700;
    padding-left: 8px;
`;

export const OptionalTextWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

export const InfoBoldedText = styled.span`
    font-weight: 700;
`;

export const PersonalInfoButton = styled(Button)(
    ({ theme: { fontSize } }) => css`
        font-size: ${fontSize['12']}px;
        line-height: ${fontSize['16']}px;
        margin-top: 24px;
        min-height: 0;
        padding-bottom: 9px;
        padding-top: 9px;
        width: 100%;
    `,
);

export const PersonalInfoFormWrapper = styled.div`
    margin-top: 20px;
`;

export const Input = styled(TextField)`
    margin-bottom: 16px;
`;
